var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6666 8.59992V11.3999C10.6666 13.7333 9.73325 14.6666 7.39992 14.6666H4.59992C2.26659 14.6666 1.33325 13.7333 1.33325 11.3999V8.59992C1.33325 6.26658 2.26659 5.33325 4.59992 5.33325H7.39992C9.73325 5.33325 10.6666 6.26658 10.6666 8.59992Z",
    stroke: "#989898",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 4.59992V7.39992C14.6666 9.73325 13.7333 10.6666 11.3999 10.6666H10.6666V8.59992C10.6666 6.26658 9.73325 5.33325 7.39992 5.33325H5.33325V4.59992C5.33325 2.26659 6.26658 1.33325 8.59992 1.33325H11.3999C13.7333 1.33325 14.6666 2.26659 14.6666 4.59992Z",
    stroke: "#989898",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.7903c6347423254bd94fce229325adc7.svg";
export { ForwardRef as ReactComponent };